module.exports = __webpack_public_path__ + "h5/img/xyzp-pan.668aedaa.png";